import {
  Compiler,
  Component,
  ComponentRef,
  Injectable,
  Injector,
  NgModule,
  OnInit,
  ReflectiveInjector,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {Observable, ReplaySubject} from "rxjs";

@Injectable()
export class ModalService {
  public activeInstances = 0;
  private vcRef: ViewContainerRef;
  private injector: Injector;

  constructor(private compiler: Compiler) {
  }

  public registerViewContainerRef(vcRef: ViewContainerRef): void {
    this.vcRef = vcRef;
  }

  public registerInjector(injector: Injector): void {
    this.injector = injector;
  }

  public create<T>(module: any, component: any, parameters?: object): Observable<ComponentRef<T>> {
    const componentRef$ = new ReplaySubject();
    this.compiler.compileModuleAndAllComponentsAsync(module)
      .then((factory) => {
        const componentFactory = factory.componentFactories.filter((item) => item.componentType === component)[0];
        const childInjector = ReflectiveInjector.resolveAndCreate([], this.injector);
        const componentRef = this.vcRef.createComponent(componentFactory, 0, childInjector);
        Object.assign(componentRef.instance, parameters); // pass the @Input parameters to the instance
        this.activeInstances++;
        componentRef.instance.componentIndex = this.activeInstances;
        componentRef.instance.destroy = () => {
          this.activeInstances--;
          componentRef.destroy();
        };
        componentRef$.next(componentRef);
        componentRef$.complete();
      });
    return componentRef$.asObservable() as Observable<ComponentRef<T>>;
  }
}

@Component({
  selector: "modal-placeholder",
  template: `<div #modalplaceholder></div>`,
})
export class ModalPlaceholderComponent implements OnInit {
  @ViewChild("modalplaceholder", { read: ViewContainerRef }) public viewContainerRef;

  constructor(private modalService: ModalService, private injector: Injector) {
  }

  public ngOnInit(): void {
    this.modalService.registerViewContainerRef(this.viewContainerRef);
    this.modalService.registerInjector(this.injector);
  }
}

export class ModalContainer {
  public destroy: () => void;
  public componentIndex: number;

  public closeModal(): void {
    this.destroy();
  }
}

export function Modal() {
  return (target) => {
    Object.assign(target.prototype, ModalContainer.prototype);
  };
}

@NgModule({
  declarations: [ModalPlaceholderComponent],
  exports: [ModalPlaceholderComponent],
  providers: [ModalService],
})
export class BaseModalComponent {
}
